export interface BenefitType {
  id: string;
  title: string;
  description?: string;
  subTitle?: string;
  buttonList: string;
  buttonDetail: string;
  imageUrl: string;
  partnerId: string;
  url: string;
  disabled: boolean;
  sortOrder?: number;
  partner: PartnerType;
  countries?: string;
  linkType?: string;
  deepLink?: string;
}

export interface FormBenefitType extends BenefitType {}

export interface FormPartnerType extends PartnerType {}

export interface PartnerType {
  id: string;
  title: string;
  partnerBrandImageUrl: string;
}

export enum BenefitStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum LinkType {
  WEB_LINK = 'WEB_LINK',
  DEEP_LINK = 'DEEP_LINK',
}

export interface SetDisabledTypePrams {
  disabled: boolean;
}

export interface SortBenefitsPayload {
  sortBenefitList: {
    id: string;
    sortOrder: number;
  }[];
}

export const LinkTypeList = [
  {
    text: 'Web Link',
    value: LinkType.WEB_LINK,
  },
  {
    text: 'App Deep Link',
    value: LinkType.DEEP_LINK,
  },
];
